import { toast } from 'react-toastify';

const ai_errors = {
  INVALID_ARGUMENTS:
    'بدنه درخواست نادرست است (خطا در فرمت یا فیلد اجباری جا افتاده)',
  FAILED_PRECONDITION:
    'برای استفاده نیاز به پلن پولی در Google AI Studio دارید.',
  PERMISSION_DENIED:
    'برای مدل های API مطمئن شوید کلید درست و مجوز کافی دارید. باید احراز هویت درست انجام شود',
  NOT_FOUND: 'منبع درخواستی پیدا نشد.',
  RESOURCE_EXHAUSTED:
    '(Rate Limit) محدودیت نرخ درخواست‌ها سمت گوگل رد شده. صبر کنید و سپس دوباره تلاش کنید.',
  INTERNAL:
    'خطای داخلی در سمت گوگل رخ داده، پیشنهاد میشه حجم ورودی رو کاهش بدید یا مدل دیگری رو تست کنید.',
  UNAVAILABLE:
    'سرویس گوگل موقتا در دسترس نیست یا ظرفیت پر شده، کمی صبر کنید یا دوباره تلاش کنید.',
  DEADLINE_EXCEEDED: 'پردازش درخواست در زمان مقرر تمام نشد.',
  SERVER_ERROR:
    'پردازش درخواست به‌دلیل ترافیک بالا یا ارسال درخواست‌های متوالی در سرورهای Google با تأخیر مواجه شده است.\nلطفا کمی بعد دوباره تلاش کنید.'
};

const handleAiError = response => {
  const msg = response?.msg;
  if (msg && ai_errors[msg]) {
    toast.error(ai_errors[msg]);
  }
  return response;
};

// تابع برای handle کردن خطاها در transformErrorResponse
// توجه: toast در customFetchBase نمایش داده می‌شود، پس اینجا نمایش نمی‌دهیم
const handleAiErrorResponse = (response, meta) => {
  // بررسی خطای 500 با code: 0
  if (meta?.response?.status === 500 && meta?.response?.data?.code === 0) {
    // برگرداندن یک error object که باعث کرش نشود
    // toast در customFetchBase نمایش داده می‌شود
    return {
      ...response,
      handled: true,
      errorMessage: ai_errors.SERVER_ERROR
    };
  }
  if (meta?.response?.status === 429) {
    return {
      ...response,
      handled: true,
      errorMessage:
        'تعداد درخواست های بیشتری از سقف مجاز برای این ساعت رخ داده است. لطفا یک ساعت دیگر دوباره تلاش کنید.'
    };
  }
  if (meta?.response?.status === 529) {
    return {
      ...response,
      handled: true,
      errorMessage: `لطفا ${meta?.response?.data?.time?.toString()} ثانیه دیگر دوباره تلاش کنید.`
    };
  }
  // بررسی خطای 500 با code: 0 از طریق error object (اگر در customFetchBase handle شده باشد)
  if (meta?.response?.status === 500 && meta?.response?.data?.errorMessage) {
    // toast در customFetchBase نمایش داده می‌شود
    return {
      ...response,
      handled: true,
      errorMessage: meta.response.data.errorMessage
    };
  }

  return response;
};

export { handleAiError, handleAiErrorResponse, ai_errors };
